new Swiper('#blog-slider', {
  // Optional parameters
  direction: 'horizontal',
  loop: false,
  slidesPerView: "auto",
  // loopedSlides: 0,
  // roundLenghts: true,
  spaceBetween: 35,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    bulletActiveClass: 'active',
    // bulletClass: 'swiper-dot'
  },

  // Navigation arrows
  navigation: {
    nextEl: '.blog-slider__next',
    prevEl: '.blog-slider__prev',
  },

  breakpoints: {
  // when window width is >= 320px
  320: {
    spaceBetween: 20
  },
  // when window width is >= 450px
  450: {
    spaceBetween: 35
  },
},

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});